import { FC } from "react";

interface canvasEmptyStateProps {
  imageSource: string;
  title: string;
  message: string;
  primaryActionLabel?: string;
  primaryAction?: () => void;
  secondaryActionLabel?: string;
  secondaryAction?: () => void;
}

// Shown in place of the item grid when a canvas has nothing in it: what the
// canvas is, why it is empty, and the one or two ways to fill it.

const CanvasEmptyState: FC<canvasEmptyStateProps> = ({
  imageSource,
  title,
  message,
  primaryActionLabel,
  primaryAction,
  secondaryActionLabel,
  secondaryAction,
}) => {
  return (
    <div className="canvasEmptyState">
      <img src={imageSource} draggable="false" alt={title} />
      <span className="canvasEmptyStateTitle">{title}</span>
      <span className="canvasEmptyStateMessage">{message}</span>
      {primaryActionLabel || secondaryActionLabel ? (
        <div className="canvasEmptyStateActionWrapper">
          {primaryActionLabel ? (
            <span
              className="canvasEmptyStateAction canvasEmptyStateActionPrimary"
              onClick={primaryAction}
            >
              {primaryActionLabel}
            </span>
          ) : (
            <></>
          )}
          {secondaryActionLabel ? (
            <span
              className="canvasEmptyStateAction"
              onClick={secondaryAction}
            >
              {secondaryActionLabel}
            </span>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default CanvasEmptyState;
